'use es6';

import { createSelectorCreator, defaultMemoize } from 'reselect';

// TODO - FIX AFTER RESELECT V3 MIGRATION: remove $hasDep branch. Once reselect v2 is retired, replace with: createSelectorCreator({ memoize: defaultMemoize, memoizeOptions: [() => false], argsMemoize: fn => fn })
// eslint-disable-next-line no-undef
export const createUnmemoizedSelector = $hasDep('reselect', '3') ? createSelectorCreator({
  memoize: defaultMemoize,
  memoizeOptions: [() => false],
  argsMemoize: fn => fn
}) : createSelectorCreator(defaultMemoize, () => false);